<div class="container" *ngIf="clientAppScreenMessage !== ''">
    <p class="text-danger text-center">{{clientAppScreenMessage}}</p>
</div>

<div class="container" *ngIf="resourceAppScreenMessage !== ''">
    <p class="text-danger text-center">{{resourceAppScreenMessage}}</p>
</div>

<display-form [displayObject]="displayObject"></display-form>

<lp-evaluation-display [result]="lpResult"></lp-evaluation-display>